import React, { useEffect, useState } from "react";
import { FaSort } from "react-icons/fa";
import ListLine from "../ListLine/ListLine";
import Pagination from "../Pagination/Pagination";
import "./List.css";
import { useListManager } from "../../contexts/list.manager";
import { useTranslation } from "react-i18next";

const List = (props) => {
	const [orderDirection, setOrderDirection] = useState("DESC");
	const { handleLineClick, lineSelected, setLineSelected, setIsCard, selectedIdx, setSelectedIdx } = useListManager();
	const [expanded, setExpanded] = useState([]);
	const [isLoading, setIsLoading] = useState(props.isLoading);
	const { t } = useTranslation();

	useEffect(() => {
		setIsLoading(props.isLoading);
	}, [props.isLoading]);

	function toggleExpanded(id) {
		const expandedIds = new Set(expanded);
		if (expandedIds.has(id)) {
			expandedIds.delete(id);
		} else {
			expandedIds.add(id);
		}
		setExpanded(Array.from(expandedIds));
	}

	useEffect(() => {
		if (!lineSelected) setIsCard(false);
		function onKeyUp(event) {
			if (lineSelected) {
				if (event.key === "Escape") {
					setLineSelected(null);
					setIsCard(false);
				}
				if (["ArrowUp", "ArrowDown"].includes(event.key)) {
					event.preventDefault();
					const newIndexByAction = {
						ArrowUp: selectedIdx > 0 ? selectedIdx - 1 : props.data.length - 1,
						ArrowDown: selectedIdx < props.data.length - 1 ? selectedIdx + 1 : 0,
					}
					const newIndex = newIndexByAction[event.key];
					handleLineClick(props.data[newIndex], newIndex);
				}
			}
		}
		window.addEventListener("keyup", onKeyUp);
		return () => {
			window.removeEventListener("keyup", onKeyUp);
		};
	}, [lineSelected]);

	return (
		<div className="list-table-wrapper">
			<table className={`list-table ${props.className || ''}`}>
				<thead>
					<tr>
						{props.collumsObjIndex &&
							props.collumsObjIndex.map((collumn, index) => (
								<th key={index} className={`list-header-th ${collumn.type === 'actions' ? 'text-right!' : ''} ${collumn?.thClass || ''} ${collumn?.columnClassName || ''}`}>
									{collumn.customHeader ? collumn.customHeader(collumn.index) : (
										<>
											<span className="list-header-span font-bold! opacity-80!">
												{collumn.forceLabel ? collumn.collumnLabel : (collumn.index?.toLowerCase()?.includes('status') ? t(`common.equipment`) : collumn.collumnLabel)}
											</span>
											{props.handleCollumnTitleClick && collumn.type !== "actions" && (
												<FaSort
													color={"gray"}
													size={11}
													style={{ marginLeft: 4 }}
												/>
											)}
										</>
									)}
								</th>
							))}
						{props.expandableContent && (
							<th className="list-header-th">

							</th>
						)}
					</tr>
				</thead>
				<tbody>
					{isLoading ? (
						<>
							{Array(5).fill(0).map((_, index) => (
								<React.Fragment key={index}>
									<tr>
										{props.collumsObjIndex && props.collumsObjIndex.map((_, objIndex) => (
											<td style={{ '--widthFactor': 1 }} key={objIndex}>
												<div style={{ '--shimmerDelay': `${Math.random() * 100}ms` }} className={`w-[calc(100%*var(--widthFactor))] h-3.5 my-[4px]! rounded-lg shimmer`}></div>
											</td>
										))}
									</tr>
								</React.Fragment>
							))}
						</>
					) : (
						<>
							{props.data?.length ? (
								props.data.map((data, index) => (
									<React.Fragment key={index}>
										<ListLine
											asTableRow={true}
											selectable={props.selectableRows}
											idx={index}
											toggleExpanded={toggleExpanded}
											{...props}
											data={data}
											expandedIds={expanded}
											key={index}
										/>
										{(props.expandableContent && (data._preload_expandable_ || expanded.includes(data._expandableId_ ?? data.id))) && (
											<tr className={`expandable-content expanded ${expanded.includes(data._expandableId_ ?? data.id) ? '' : 'hidden!'}`}>
												<td colSpan={props.collumsObjIndex?.length + 1}>
													{props.expandableContent({ row: data, toggleExpanded })}
												</td>
											</tr>
										)}
									</React.Fragment>
								))
							) : (
								<tr>
									<td colSpan={props.collumsObjIndex?.length || 1}>
										<div className="empty-list-message opacity-45">
											Nenhum registro encontrado
										</div>
									</td>
								</tr>
							)}
						</>
					)}
				</tbody>
			</table>
			{
				props.changePage && (
					<Pagination
						rowsPerPage={props.rowsPerPage}
						maxPage={props.maxPage}
						changePage={(page) => props.changePage(page)}
					/>
				)
			}
		</div >
	);
};

export default List;
